import { IOption } from "../components/ui/Input/Input";
import { EMeetingPoint, EMeetingPointAirport, ETerminal } from "./bookingEnums";

export const timeOptions: IOption[] = Array.from({ length: 48 }, (_, i) => {
  const hours = Math.floor(i / 2).toString().padStart(2, "0");
  const minutes = i % 2 === 0 ? "00" : "30";
  const time = `${hours}:${minutes}`;
  return { value: time, label: time };
});

export const meetingPointOptions: IOption[] = [
  { label: "Rental station", value: EMeetingPoint.RENTAL_STATION },
  { label: "Airport", value: EMeetingPoint.AIRPORT },
];

export const meetingPointAirportOptions: IOption[] = [
  { label: "Arrival by flight on pickup date", value: EMeetingPointAirport.FLIGHT },
  { label: "No flight, pickup transfer from meeting point at Terminal", value: EMeetingPointAirport.NO_FLIGHT },
];

export const terminalOptions: IOption[] = [
  { label: ETerminal.T1, value: ETerminal.T1 },
  { label: ETerminal.T2, value: ETerminal.T2 },
  { label: ETerminal.T3, value: ETerminal.T3 },
  { label: ETerminal.T4, value: ETerminal.T4 },
  { label: ETerminal.T5, value: ETerminal.T5 },
];

export const extrasDefaultTrue = ["IBS", "NAV", "VLB", "TCC", "STI", "STSA"];
export const extrasBlacklist = ["BSC", "STS"];
